import T, { MDText } from 'i18n-react';

import texts from 'Components/texts.json';
import type { GradingValues, VehicleRating } from 'Pages/vehicles/helpers/vehicle.schema';
import { GRADE_VALUES } from 'Pages/vehicles/helpers/vehicle.schema';

import localTexts from './ExteriorGrading.texts';

T.setTexts(texts);

const LocalT = new MDText(localTexts);

export const getExteriorGradeText = (grade: VehicleRating['grade']) => `${LocalT.translate(`exteriorGrades.${grade}`)}`;

export const EXTERIOR_GRADE_DETAILS_KEYS = [
	'scratchesAndScuffs',
	'dents',
	'paintworkProblems',
	'windscreenDamage',
	'scuffedAlloys',
	'warningLightsOnDashboard',
] as const;

export const EXTERIOR_GRADING_TABLE_CONFIG = EXTERIOR_GRADE_DETAILS_KEYS.map((detailKey) => {
	const label = localTexts.labels[detailKey];
	const grades = GRADE_VALUES.reduce(
		(row, grade) => {
			row[grade] = `${LocalT.translate(`values.${grade}.${detailKey}`)}`;
			return row;
		},
		{} as Record<GradingValues, string>,
	);

	return { label, ...grades };
});

export const EXTERIOR_GRADE_FIELDS = EXTERIOR_GRADE_DETAILS_KEYS.map((detailKey) => ({
	key: detailKey,
	label: `${LocalT.translate(`labels.${detailKey}`)}`,
	value: detailKey,
}));
